import Notifications from "./index.vue";
import Vue from "vue";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";
import {
  getContentOffer,
  getContentOffers,
  restoreContentOffer,
  updateContentOffer
} from "@/api";
import { debounce } from "lodash";
import { CombinedVueInstance } from "vue/types/vue";
import { ApiResponse } from "@/api/types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  data() {
    return {
      isLoadingOnFetch: false,
      isLoadingOnSave: false,
      selectedOfferId: undefined,
      offers: undefined,
      offerDetails: {}
    };
  },
  computed: {
    selectedOfferDetail() {
      if (this.selectedOfferId === undefined) return;
      return this.offerDetails[this.selectedOfferId];
    }
  },
  async mounted() {
    await this.getOffers();
    const initialId = this.offers?.content_offers[0]?.content_offer[0].id;
    initialId && this.getOffer(initialId);
  },
  methods: {
    async getOffers() {
      this.isLoadingOnFetch = true;
      const { data } = await getContentOffers();
      this.offers = data;
      this.isLoadingOnFetch = false;
    },
    async getOffer(offerId) {
      if (this.offerDetails[offerId]) {
        this.selectedOfferId = offerId;
        return;
      }

      try {
        const { data } = await getContentOffer({ offerId });
        let offersItem: ApiResponse.ContentOffersItem | undefined;
        let graduateYear: number | undefined;
        this.offers?.content_offers.forEach(offerItems =>
          offerItems.content_offer.forEach(item => {
            if (item.id === offerId) {
              offersItem = item;
              graduateYear = offerItems.graduate_year;
            }
          })
        );

        this.offerDetails = {
          ...this.offerDetails,
          [offerId]: {
            ...data,
            ...offersItem,
            graduateYear
          }
        };
      } catch (error) {
        this.selectedOfferId = undefined;
        throw error;
      } finally {
        this.selectedOfferId = offerId;
      }
    },
    updateMailTemplate: debounce(async function(
      this: CombinedVueInstance<
        Vue,
        ContainerData,
        ContainerMethods,
        ContainerComputed,
        ContainerProps
      >,
      text
    ) {
      if (!this.selectedOfferId) return;
      this.isLoadingOnSave = true;

      const preText = this.offerDetails[this.selectedOfferId].mail_body;

      this.offerDetails[this.selectedOfferId].mail_body = text;

      try {
        await updateContentOffer({
          offerId: this.selectedOfferId,
          mail_body: text
        });
        this.offerDetails[this.selectedOfferId].lastUpdatedAt = new Date();
      } catch (error) {
        this.offerDetails[this.selectedOfferId].mail_body = preText;
      } finally {
        this.isLoadingOnSave = false;
      }
    },
    500),
    async resetMailTemplateConfirm() {
      if (!this.selectedOfferId) return;
      this.isLoadingOnSave = true;

      const { data } = await restoreContentOffer({
        offerId: this.selectedOfferId
      });
      this.offerDetails[this.selectedOfferId].lastUpdatedAt = new Date();
      this.offerDetails[this.selectedOfferId].mail_body = data.mail_body;
      this.isLoadingOnSave = false;
    }
  },
  render(createElement) {
    return createElement(Notifications, {
      props: {
        isLoadingOnFetch: this.isLoadingOnFetch,
        isLoadingOnSave: this.isLoadingOnSave,
        offers: this.offers,
        selectedOfferId: this.selectedOfferId,
        selectedOfferDetail: this.selectedOfferDetail
      },
      on: {
        onClickResetMailTemplateConfirm: this.resetMailTemplateConfirm,
        onChangeMailTemplate: this.updateMailTemplate,
        onClickMenu: this.getOffer
      }
    });
  }
});
